
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/eb8ff83a3546fe57070bf812bafc35d3.jpeg" 
              alt="ZOLLER" 
              className="h-10 w-auto object-contain"
            />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
              製品特徴
            </a>
            <a href="#demo" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
              デモ申込
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap">
              お問い合わせ
            </a>
          </nav>

          <button
            className="md:hidden p-2 rounded-md hover:bg-gray-100 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                製品特徴
              </a>
              <a href="#demo" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                デモ申込
              </a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                お問い合わせ
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
